import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=2c99af2b&"
import script from "./TreeItem.vue?vue&type=script&lang=js&"
export * from "./TreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=2c99af2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports